import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type SetExtractionAcknowledgedMutationVariables = Types.Exact<{ [key: string]: never }>;

export type SetExtractionAcknowledgedMutation = {
  __typename?: 'Mutation';
  setExtractionAcknowledged: string;
};

export const SetExtractionAcknowledgedDocument = gql`
  mutation setExtractionAcknowledged {
    setExtractionAcknowledged
  }
`;
export type SetExtractionAcknowledgedMutationFn = Apollo.MutationFunction<
  SetExtractionAcknowledgedMutation,
  SetExtractionAcknowledgedMutationVariables
>;

/**
 * __useSetExtractionAcknowledgedMutation__
 *
 * To run a mutation, you first call `useSetExtractionAcknowledgedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExtractionAcknowledgedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExtractionAcknowledgedMutation, { data, loading, error }] = useSetExtractionAcknowledgedMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetExtractionAcknowledgedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetExtractionAcknowledgedMutation,
    SetExtractionAcknowledgedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetExtractionAcknowledgedMutation,
    SetExtractionAcknowledgedMutationVariables
  >(SetExtractionAcknowledgedDocument, options);
}
export type SetExtractionAcknowledgedMutationHookResult = ReturnType<
  typeof useSetExtractionAcknowledgedMutation
>;
export type SetExtractionAcknowledgedMutationResult =
  Apollo.MutationResult<SetExtractionAcknowledgedMutation>;
export type SetExtractionAcknowledgedMutationOptions = Apollo.BaseMutationOptions<
  SetExtractionAcknowledgedMutation,
  SetExtractionAcknowledgedMutationVariables
>;
